import { scrollToElementWithStickyOffset } from "../../../common/js/helpers"

export default (commonBasicPlanCheckout) =>
  ({ planSelectionPath, paymentsPath, isTrackVisitCheckout, isAbandonedBasket } = {}) => ({
    // Init basic common checkout functionality

    ...commonBasicPlanCheckout({
      planSelectionPath,
      paymentsPath,
      isTrackVisitCheckout,
      isAbandonedBasket,
    }),

    // Add brand-specific checkout functionality or overwrite common

    init() {
      this.commonInit()
      this.store.internalTracker.initDefaultSelectedPlan()
    },

    submitOffer() {
      this.store.internalTracker.setEventToSessionStorage({ clickName: "Get Plan Clicked" })
      this.store.internalTracker.trackGetMyPlanClicked()
      this.commonSubmitOffer()
    },

    selectOffer(offer) {
      this.activeOffer = offer
      this.store.values.activeOffer = offer

      this.store.internalTracker.trackClick({ clickName: "Plan Selected" })
      this.store.internalTracker.trackSelectPlan()
    },

    handleButtonClickWithScrollOffset(options = {}) {
      const { targetSelector = "#offer-container", stickySelector = "#sticky-top-banner", offset = 12, trackingName = "Anchor Clicked" } = options
      this.store.internalTracker.trackClick({ clickName: trackingName })
      scrollToElementWithStickyOffset({ targetSelector, stickySelector, offset })
    },
  })
